import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAsyncDispatchWithErrorToast } from './hooks/useAsyncDispatchWithErrorToast'
import {
  ContractorPortalFetchDriver,
  ContractorPortalFetchPartner,
  ContractorPortalFetchPartners,
  FetchRemoteConfig,
} from './constants/actionTypes'
import { Driver } from './interfaces/driver'

export const ContractorPortalSecureHooksContainer = memo(() => {
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast('contractorPortal')
  const dispatch = useDispatch()

  // Plain dispatch, not the toast: a failed load keeps the built-in values and shows nothing.
  useEffect(() => {
    dispatch(FetchRemoteConfig.request({ platform: 'contractorPortal' }))
  }, [dispatch])

  useEffect(() => {
    const initUser = async () => {
      try {
        const user = await asyncDispatchWithErrorToast<Driver>(
          ContractorPortalFetchDriver.request(),
        )

        if (user) {
          await asyncDispatchWithErrorToast(
            ContractorPortalFetchPartners.request({ phone: user.phone }),
          )
        }

        await asyncDispatchWithErrorToast(ContractorPortalFetchPartner.request())
      } catch {}
    }

    initUser()
  }, [])

  return null
})
